(function() {

  function showDetail() {
    $('.collapse__icon').click(function () {
      $(this).toggleClass('is-active');
      $("#" + $(this).data('box')).slideToggle();
      return false;
    })
  }


  const isCampaignPage = $('.campaign').length;
  if(isCampaignPage) {
    showDetail();
  }
})();
